module.exports = __webpack_public_path__ + "static/img/6.a3563f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/04/6.png
// module id = 6QdW
// module chunks = 1